import React from 'react';
import type { FuelSavingsResultProps } from '../types';
import { formatCurrency, getSavingsColor } from '../utils';
import { ColoredResultValue, ResultLabel, ResultRow, SavingsContainer, SavingsHeaderLabel } from './FuelSavingAnalysis.styles';

export const FuelSavingsResult: React.FC<FuelSavingsResultProps> = ({ monthly, yearly, threeYears }) => {
    return (
        <SavingsContainer data-testid="fuel-saving-results">
            <SavingsHeaderLabel>Total Savings:</SavingsHeaderLabel>
            <ResultRow data-testid="fuel-saving-results-row-monthly">
                <ResultLabel>Monthly</ResultLabel>
                <ColoredResultValue data-testid="fuel-saving-results-value-monthly" $color={getSavingsColor(monthly)}>
                    {formatCurrency(monthly)}
                </ColoredResultValue>
            </ResultRow>
            <ResultRow data-testid="fuel-saving-results-row-yearly">
                <ResultLabel>Yearly</ResultLabel>
                <ColoredResultValue data-testid="fuel-saving-results-value-yearly" $color={getSavingsColor(yearly)}>
                    {formatCurrency(yearly)}
                </ColoredResultValue>
            </ResultRow>
            <ResultRow data-testid="fuel-saving-results-row-three-years">
                <ResultLabel>3 Years</ResultLabel>
                <ColoredResultValue data-testid="fuel-saving-results-value-three-years" $color={getSavingsColor(threeYears)}>
                    {formatCurrency(threeYears)}
                </ColoredResultValue>
            </ResultRow>
        </SavingsContainer>
    );
};
